<template>
    <vx-button @click="handleClick"
        :href="href">
        <slot />
    </vx-button>
</template>

<script setup lang="ts">
import { VxButton } from '@voxie/frontend-components';
import { computed } from 'vue';
import { useRouter, type RouteLocationRaw } from 'vue-router';
import { useRouterNavigation } from '~/composables/useRouterNavigation';

const props = defineProps<{
    to: RouteLocationRaw;
}>();

const router = useRouter();
const { navigate } = useRouterNavigation();

const href = computed((): string => {
    return router.resolve(props.to).href;
});

const handleClick = (event: MouseEvent|KeyboardEvent) => {
    navigate(props.to, event);
}
</script>
